import React from "react";
import {
  Accordion,
  AccordionItem,
  AccordionItemHeading,
  AccordionItemPanel,
  AccordionItemButton,
} from "react-accessible-accordion";

const Faq = () => {
  return (
    <div className="accordion__wrapper1">
      <Accordion className="accordion" preExpanded={"a"}>
        <AccordionItem className="accordion-item" uuid="a">
          <AccordionItemHeading className="accordion-button">
            <AccordionItemButton className="card-link">
              What courses does IAS Jnani offer for UPSC preparation?
            </AccordionItemButton>
          </AccordionItemHeading>
          <AccordionItemPanel className="accordion-body">
            <p>
              IAS Jnani offers a comprehensive UPSC preparation program,
              including GS Prelims & Mains, Essay Writing, Optional Subjects,
              and Current Affairs analysis.
            </p>
          </AccordionItemPanel>
        </AccordionItem>
        <AccordionItem className="accordion-item" uuid="b">
          <AccordionItemHeading className="accordion-button">
            <AccordionItemButton className="card-link">
              Why choose IAS Jnani over other UPSC coaching institutes?
            </AccordionItemButton>
          </AccordionItemHeading>
          <AccordionItemPanel className="accordion-body">
            <p>
              IAS Jnani stands out due to its unique teaching methodology,
              structured curriculum, expert faculty, and exclusive focus on UPSC
              preparation.
            </p>
          </AccordionItemPanel>
        </AccordionItem>
        <AccordionItem className="accordion-item" uuid="c">
          <AccordionItemHeading className="accordion-button">
            <AccordionItemButton className="card-link">
              What is the duration of the IAS Jnani UPSC course?
            </AccordionItemButton>
          </AccordionItemHeading>
          <AccordionItemPanel className="accordion-body">
            <p>
              The UPSC course at IAS Jnani runs for 7 months, covering
              Prelims, Mains, and Interview preparation with structured classes
              and regular tests.
            </p>
          </AccordionItemPanel>
        </AccordionItem>
        <AccordionItem className="accordion-item" uuid="d">
          <AccordionItemHeading className="accordion-button">
            <AccordionItemButton className="card-link">
              How does IAS Jnani help with UPSC answer writing practice?
            </AccordionItemButton>
          </AccordionItemHeading>
          <AccordionItemPanel className="accordion-body">
            <p>
              Our program includes daily answer writing practice, expert
              evaluation, and personalized feedback to improve writing skills
              and boost Mains scores.
            </p>
          </AccordionItemPanel>
        </AccordionItem>
        <AccordionItem className="accordion-item" uuid="e">
          <AccordionItemHeading className="accordion-button">
            <AccordionItemButton className="card-link">
              What study materials are provided at IAS Jnani?
            </AccordionItemButton>
          </AccordionItemHeading>
          <AccordionItemPanel className="accordion-body">
            <p>
              We provide well-researched notes, NCERT summaries, standard
              booklists, and exclusive current affairs magazines for UPSC
              preparation.
            </p>
          </AccordionItemPanel>
        </AccordionItem>
        <AccordionItem className="accordion-item" uuid="f">
          <AccordionItemHeading className="accordion-button">
            <AccordionItemButton className="card-link">
              Do you offer mentorship and doubt-clearing sessions?
            </AccordionItemButton>
          </AccordionItemHeading>
          <AccordionItemPanel className="accordion-body">
            <p>
              Yes, IAS Jnani provides one-on-one mentorship, doubt-clearing
              sessions, and strategic guidance to ensure focused preparation.
            </p>
          </AccordionItemPanel>
        </AccordionItem>
        <AccordionItem className="accordion-item" uuid="g">
          <AccordionItemHeading className="accordion-button">
            <AccordionItemButton className="card-link">
              How does IAS Jnani cover UPSC current affairs?
            </AccordionItemButton>
          </AccordionItemHeading>
          <AccordionItemPanel className="accordion-body">
            <p>
              We offer daily current affairs analysis, monthly compilations, and
              topic-wise discussions to ensure thorough coverage of current
              events.
            </p>
          </AccordionItemPanel>
        </AccordionItem>
        <AccordionItem className="accordion-item" uuid="h">
          <AccordionItemHeading className="accordion-button">
            <AccordionItemButton className="card-link">
              Does IAS Jnani provide mock tests and test series?
            </AccordionItemButton>
          </AccordionItemHeading>
          <AccordionItemPanel className="accordion-body">
            <p>
              Yes, we conduct regular mock tests for Prelims and Mains, along
              with detailed performance analysis and improvement strategies.
            </p>
          </AccordionItemPanel>
        </AccordionItem>
        <AccordionItem className="accordion-item" uuid="i">
          <AccordionItemHeading className="accordion-button">
            <AccordionItemButton className="card-link">
              What is the success rate of IAS Jnani students in UPSC?
            </AccordionItemButton>
          </AccordionItemHeading>
          <AccordionItemPanel className="accordion-body">
            <p>
              IAS Jnani has a high success rate, with many students clearing
              UPSC exams due to our rigorous training and structured approach.
            </p>
          </AccordionItemPanel>
        </AccordionItem>
        <AccordionItem className="accordion-item" uuid="j">
          <AccordionItemHeading className="accordion-button">
            <AccordionItemButton className="card-link">
              How do I enroll in IAS Jnani’s UPSC coaching program?
            </AccordionItemButton>
          </AccordionItemHeading>
          <AccordionItemPanel className="accordion-body">
            <p>
              You can enroll through our website by filling out the admission
              form or visiting our institute for offline registration or you can simply WhatsApp us.
            </p>
          </AccordionItemPanel>
        </AccordionItem>
      </Accordion>
    </div>
  );
};

export default Faq;
